<template>
  <div class="productDustribut">
    <div class="block">
      <div class="navCalss">| 客户列表</div>

      <div class="minWidth">
        <el-form
          :inline="true"
          ref="search_data"
          class="demo-form-inline search-form"
        >
          <el-row>
            <el-col :span="7">
              <el-form-item label="客户名称/vip号:">
                <el-input
                  v-model="searchData.keyWordB"
                  placeholder="请输入客户名称/vip号"
                  @keyup.enter.native="initData()"
                  clearable
                  @clear="initData()"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="昵称:">
                <el-input
                  v-model="searchData.keyWord"
                  placeholder="请输入昵称"
                  @keyup.enter.native="initData()"
                  clearable
                  @clear="initData()"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号:">
                <el-input
                  v-model="searchData.keyWordC"
                  placeholder="请输入手机号"
                  @keyup.enter.native="initData()"
                  clearable
                  @clear="initData()"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" icon="search" @click="initData()"
                >搜索</el-button
              >
            </el-col>
          </el-row>
          <el-row> </el-row>
        </el-form>
      </div>
    </div>

    <div class="table_container">
      <el-button
        type="primary"
        icon="search"
        @click="routerTo"
        style="float: right; margin-bottom: 10px"
        >充 值</el-button
      >
      <el-table
        :data="customerList"
        border
        style="width: 100%"
        @sort-change="sortBalance"
        :default-sort="{ prop: 'balance', order: 'descending' }"
        stripe
      >
        <el-table-column
          prop="adminId"
          label="序号"
          align="center"
          min-width="50px"
        >
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column label="头像" header-align="center" width="160px">
          <template slot-scope="scope">
            <div class="wrl-flex" align="center">
              <div>
                <el-image
                  class="imgRaduis"
                  style="width: 50px; height: 50px"
                  :src="scope.row.photo"
                  fit="contain"
                ></el-image>
              </div>
              <div class="wrl-name">
                {{ scope.row.nickname }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="真实姓名" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.realName">{{ scope.row.realName }}</div>
            <div v-else>无</div>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" align="center" width="100px">
          <template slot-scope="scope">
            {{ scope.row.addDate }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
          </template>
        </el-table-column>
        <el-table-column label="VIP号" align="center">
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column label="工单配额" align="center">
          <template slot-scope="scope">
            {{ scope.row.demandCount }}
          </template>
        </el-table-column>
        <el-table-column
          label="余额"
          align="center"
          prop="balance"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column label="消费金额" align="center" prop="amount">
        </el-table-column>
        <el-table-column label="派送点" align="center">
          <template slot-scope="scope">
            <div>
              <p>{{ scope.row.deliveryTitle }}</p>
              <p>{{ scope.row.deliveryAddress }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户备注" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="editUser(scope.row)">修改</el-button>
            <el-button type="text" @click="delAppendUser(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :visible.sync="editDialog.show"
      :title="editDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="400px"
      center
      :show-close="false"
    >
      <el-form
        :model="editDialog.data"
        :rules="editDialog.form_rules"
        ref="editForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item prop="realName" label="用户名：">
          <el-input
            v-model="editDialog.data.realName"
            type="text"
            placeholder="请输入用户名"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号：">
          <el-input
            v-model.trim="editDialog.data.mobile"
            type="text"
            placeholder="请输入手机号"
            style="width: 200px"
            minlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item prop="demandCount" label="工单预期：">
          <el-input
            v-model.trim="editDialog.data.demandCount"
            type="text"
            placeholder="工单预期"
            style="width: 200px"
            minlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="客户备注：">
          <el-input
            v-model.trim="editDialog.data.remark"
            type="text"
            placeholder="客户备注"
            style="width: 200px"
            minlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item prop="deliveryId" label="派送点：">
          <el-select
            v-model="editDialog.data.deliveryId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in deliveryList"
              :key="item.addressId"
              :label="item.deliveryTitle"
              :value="item.addressId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="submitUser()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="deleteDialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      style="text-align: center"
    >
      <span>您确定删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="deleteUser()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as customer from "@/api/customer";
import * as deliveryApi from "@/api/delivery";
import { axios } from "utils/";
export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "realName") text = "用户名";
        else if (rule.field == "mobile") text = "手机号";
        else if (rule.field == "demandCount") text = "工单配额";
        else if (rule.field == "deliveryId") text = "派送点";
        return callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "demandCount") {
          var reg = /^\d+$|^\d*\.\d+$/g;
          if (!reg.test(value)) {
            callback(new Error("只能输入数字和小数点"));
          }
        }
        return callback();
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改用户",
        data: {
          userId: null,
          realName: "",
          mobile: "",
          remark: "",
          demandCount: "",
          deliveryId: null,
        },
        form_rules: {
          realName: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          mobile: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          demandCount: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          deliveryId: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
        },
      },
      deleteDialog: {
        show: false,
        title: "删除用户",
      },
      deliveryList: [],
      galVal: "",
      radio: "",
      searchData: {
        keyWord: "",
        keyWordB: "",
        keyWordC: "",
      },
      dialog: {
        show: false,
        showB: false,
      },
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 20, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      customerList: [], //列表,
      sortWay: "1", // 排序方式 1降序 2升序
    };
  },
  created() {
    let that = this;
    that.userId = that.$route.query.userId || "";
    that.getCustomer();
    that.getDeliveryList();
  },

  methods: {
    initData() {
      this.paginations.page_index = 1;
      this.getCustomer();
    },
    editUser(row) {
      this.editDialog.show = true;
      this.editDialog.data = {
        userId: row.userId,
        realName: row.realName,
        mobile: row.mobile,
        demandCount: row.demandCount,
        remark: row.remark,
        deliveryId: row.deliveryId || null,
      };
    },
    delAppendUser(row) {
      this.deleteDialog.show = true;
      this.editDialog.data = {
        userId: row.userId,
      };
    },
    routerTo() {
      this.$router.push("/recharge/charge");
    },
    submitUser() {
      let that = this;
      let data = {};
      data.userId = that.editDialog.data.userId;
      data.realName = that.editDialog.data.realName;
      data.mobile = that.editDialog.data.mobile;
      data.demandCount = that.editDialog.data.demandCount;
      data.remark = that.editDialog.data.remark;
      data.deliveryId = that.editDialog.data.deliveryId;
      that.$refs.editForm.validate((valid) => {
        if (valid) {
          customer.updateUserInfo(data).then(function (res) {
            if (res.data.code == 1202) {
              that.$router.push("/login");
              return;
            }
            if (res.data.code != 0) {
              that.$message.error(res.data.msg || "操作失败");
              return;
            }
            that.$message({
              message: "操作成功",
              type: "success",
            });

            that.getCustomer();
            that.editDialog.show = false;
          });
        }
      });
    },
    deleteUser() {
      let that = this;
      let data = {};
      data.userId = that.editDialog.data.userId;

      customer.del(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success",
        });

        that.getCustomer();
        that.deleteDialog.show = false;
      });
    },
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },
    getCustomer(page) {
      let that = this;
      if (page) {
        that.paginations.page_index = 1;
      }
      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        nickname: that.searchData.keyWord ? that.searchData.keyWord : null,
        realName: that.searchData.keyWordB ? that.searchData.keyWordB : null,
        mobile: that.searchData.keyWordC ? that.searchData.keyWordC : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        sort: that.sortWay,
      };
      customer.getCustomerList(data).then((res) => {
        console.log(res);
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.customerList = res.data.data.list;
          that.customerList &&
            that.customerList.length > 0 &&
            that.customerList.forEach(function (val, i) {
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
            });
          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDeliveryList() {
      let that = this;
      let data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDate(value1) {
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;

      that.getCustomer();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;

      that.getCustomer();
    },

    // 金额排序
    sortBalance(column) {
      if (this.sortWay == "1") {
        // 如果当前是降序，那么点击变成升序排列
        this.sortWay = "2";
        this.getCustomer(1);
      } else if (this.sortWay == "2") {
        // 反之同理
        this.sortWay = "1";
        this.getCustomer(1);
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped lang="less">
.costPrice {
  color: #f40;
}
.salePrice {
  text-decoration: line-through;
  color: #9b9b9b;
}
// }
@media screen and (min-width: 1450px) {
  .productDustribut {
    margin: 40px 20px 50px 20px;
  }
}
@media screen and (max-width: 1450px) {
  .productDustribut {
    margin: 40px 20px 50px 20px;
  }
}
.productDustribut {
  margin: 40px 40px 80px 40px;
  .search_container {
    position: relative;
    .btnRight {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .el-table__header th {
    border-right: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
  }
  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.ellipsis {
  margin-left: 5px;
  max-width: 360px;
  max-height: 60px;
  //  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.table_container {
  text-align: center;
}
.ss {
  cursor: pointer;
  color: #409eff;
}
//   .el-table td, .el-table th {
//     /* padding: 12px 0; */
//     min-width: 0;
//     -webkit-box-sizing: border-box;
//     box-sizing: border-box;
//     text-overflow: ellipsis;
//     vertical-align: middle;
//     position: relative;
//     text-align: left;
// }
.block {
  margin: 20px 0 20px 10px;
}
.sortButton {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  font-weight: 500;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  .text {
    float: left;
  }
  .arrowBox {
    float: left;
    margin-left: 6px;
    .inner {
      position: relative;
      .arrowUp {
        position: absolute;
        top: 0px;
      }
      .arrowDown {
        position: absolute;
        top: 6px;
        margin-top: 2px;
        color: black;
      }
    }
  }
}
.margin {
  line-height: 40px;
  min-height: 40px;
}
.minWidth {
  min-width: 1200px;
  margin-top: 20px;
}
.imgRaduis {
  border-radius: 50%;
}
.spaceLine {
  line-height: 30px;
  min-height: 30px;
}
.fontSize {
  font-size: 16px;
  font-weight: bold;
}
.wrl-flex {
  display: flex;
  justify-content: left;
  margin-left: 25px;
  align-items: center;
}
.wrl-name {
  margin-left: 10px;
}
.wrl-hedaer {
  font-size: 25px;
  margin: 20px 0;
}
.el-icon-question {
  font-size: 20px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// customerList.vue?35cca251